// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accent-wrapper[data-v-1590e5bc]{border-left:.4rem solid rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
